
import { useNavigate } from 'react-router-dom';
import { LandingHeader } from '../../components/layouts/LandingHeader';

export function RegisterPage() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 text-center">
            <LandingHeader />
            <div className="pt-32">
                <h1 className="text-3xl font-bold mb-4">Register Page</h1>
                <p className="mb-4">This is a placeholder for the registration page.</p>
                <button
                    onClick={() => navigate('/dev-dashboard')}
                    className="text-blue-600 hover:underline"
                >
                    Go to Dev Dashboard
                </button>
            </div>
        </div>
    );
}
